import {useQuery} from "react-query";
import {DIGITAL_SIGNING_OFFERED_KEY} from "../digitalSigningQueries";
import {DigitalSigningTemplateService} from "./digitalSigningTemplate.service";

/** Returns whether digital signing is configured and offered in the given sector. */
export const useDigitalSigningOffered = (sectorId: string | undefined): boolean | undefined => {
    const query = useQuery(
        DIGITAL_SIGNING_OFFERED_KEY,
        () => DigitalSigningTemplateService.offeredSectorIds(),
        {enabled: !!sectorId, staleTime: 5 * 60 * 1000, refetchOnWindowFocus: false}
    );
    if (!sectorId || !query.data) return undefined;
    return query.data.includes(sectorId);
};
